<template>
    <div>
        <v-row v-for="(w, i) in warningsList" :key="i" no-gutters>
            <v-col class="py-0">
                <v-alert v-if="typeof w === 'string'" text outlined dense icon="mdi-alert" type="warning" class="mt-0 mb-1" v-html="w"></v-alert>

                <!-- liquor-control warning with buttons -->
                <v-alert text outlined dense icon="mdi-alert" type="warning" class="mt-0 mb-1"v-else-if=" w.type === 'liquorControl' && !order.orderOptions[order.rate_selected.carrier_id].domestic.addressee_only_option_set">
                    {{ w.text }}
                    <v-btn class="ml-1" x-small color="success" @click="setAddresseeOnly(true)">Yes</v-btn> or <v-btn class="ml-1" x-small color="error" @click="setAddresseeOnly(false)">No</v-btn>
                </v-alert>
            </v-col>
        </v-row> 
    </div>
</template>

<script>
import warnings from "@/V2/helpers/warnings";
import Vue from 'vue';
export default {
    props: ['order'],
    methods: {
        setAddresseeOnly (val) {
            try {
                Vue.set(this.order.orderOptions[this.order.rate_selected.carrier_id].domestic, 'addressee_only', val)
                Vue.set(this.order.orderOptions[this.order.rate_selected.carrier_id].domestic, 'addressee_only_option_set', true)
                Vue.set(this.order.orderOptions[this.order.rate_selected.carrier_id], 'modified', true)
                this.$store.dispatch('Orders/save', this.order)
            } catch (e) {
                console.error('Error setting addressee only:', e);
            }
        }
    },
    computed: {
        warningsList: function () {
            return warnings.check_for_warnings(this.order)
        },
        warning: function () {
            return warnings.check_for_warnings(this.order)
        },
        warning_html: function () {
            return this.warning.join('<br>')
        }
    }
}
</script>
